import { WipState } from '../../state';

export const EMPTY_WIP_STATE: WipState = Object.freeze({
  pageKey: null,
});
